export const getCurrentUnixTimestamp = () => Math.floor(new Date().getTime())
